import _ from "underscore";
import AsnStore from "../../../stores/AsnStore";
import stores from "../../../stores";
import C from "../constants";
const {INITIAL_ASN_RELATED_SNAPSHOT} = C;

let singleton;

export default function asnInitialSnapshotFactory(options){
  if(singleton){
    singleton.setOptions(options);
    return singleton;
  }
  else{
    singleton = new AsnInitialSnapshot(options);
    singleton.init();
    return singleton;
  }
}

function AsnInitialSnapshot(options){
  const self = this;
  const opts = {};
  setOptions(options);

  const storesSnapshotConfig = [
    {
      storeName: "AsnStore"
    },
    {
      storeName: "AsnDetailStore"
    }
  ];

  self.setOptions = setOptions;

  function setOptions(options={}){
    _.extend(opts, options);
  }

  self.init = function(){

  }

  self.createSnapshots = createSnapshots;


  function createSnapshots(){
   _(storesSnapshotConfig).map(createSnapshotForStoreName);
   // logAllSnapshots();
  }

  function createSnapshotForStoreName({storeName}){
    stores[storeName].createDataSnapshot(INITIAL_ASN_RELATED_SNAPSHOT);
  }

  // function logAllSnapshots(){
  //   _(storesSnapshotConfig).map(({storeName})=>{
  //     console.log(`${storeName} snapshots:`);
  //     console.log(stores[storeName].getDataSnapshots());
  //   });
  // }
}


// WEBPACK FOOTER //
// ./src/pages/asns/businessLogic/asnInitialSnapshotFactory.js